import WebLayout from './FileUploaderWidgetLayout.web';
import MobileLayout from './FileUploaderWidgetLayout.mobile';

import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
